module.exports = __webpack_public_path__ + "static/img/course8.0fb904e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/teacher/course8.png
// module id = R5NL
// module chunks = 63